module.exports = __webpack_public_path__ + "static/media/ibm_logo.6d325fec.png";